// extracted by mini-css-extract-plugin
module.exports = {"prof":"home_prof__2rdvF","intro":"home_intro__nzRhr","p":"home_p__1aFYK","link":"home_link__3fjiV","wrapper":"home_wrapper__2d9l0"};